// ==========================================================================
// Plyr Polyfilled Build
// plyr.js v3.0.1
// https://github.com/sampotts/plyr
// License: The MIT License (MIT)
// ==========================================================================

import 'babel-polyfill';

import 'custom-event-polyfill';

import Plyr from './plyr';

export default Plyr;
